import * as React from "react";
import { useTranslation } from "react-i18next";
import withParams from "routing/withParams";
import { DocumentTitle, PageHeader } from "components/common";
import UsersPageNavigation from "components/users/navigation/UsersPageNavigation";
import DocsHelper from "util/DocsHelper";
import useTeam from "../hooks/useTeam";
import TeamEdit from "../components/team-edit/TeamEdit";
import TeamActionLinks from "../components/navigation/TeamActionLinks";
const PageTitle = ({ name }) => {
  const { t } = useTranslation("enterprise_security");
  return /* @__PURE__ */ React.createElement(React.Fragment, null, t("team_edit_page.title"), " ", name && /* @__PURE__ */ React.createElement(React.Fragment, null, "- ", /* @__PURE__ */ React.createElement("i", null, name)));
};
const TeamEditPage = ({ params }) => {
  const { t } = useTranslation("enterprise_security");
  const teamId = params == null ? void 0 : params.teamId;
  const { data: team } = useTeam(teamId);
  const name = team == null ? void 0 : team.name;
  return /* @__PURE__ */ React.createElement(DocumentTitle, { title: t("team_edit_page.document_title", { name: name != null ? name : "" }) }, /* @__PURE__ */ React.createElement(UsersPageNavigation, null), /* @__PURE__ */ React.createElement(
    PageHeader,
    {
      title: /* @__PURE__ */ React.createElement(PageTitle, { name }),
      actions: /* @__PURE__ */ React.createElement(TeamActionLinks, { team }),
      documentationLink: {
        title: t("team_edit_page.documentation_link"),
        path: DocsHelper.PAGES.USERS_ROLES
      }
    },
    /* @__PURE__ */ React.createElement("span", null, t("team_edit_page.description"))
  ), /* @__PURE__ */ React.createElement(TeamEdit, { team }));
};
export default withParams(TeamEditPage);
